<template>
    <v-row>
        <v-col>
            <v-card class="mb-3">
                <v-card-text align="end">
                    <v-btn size="small" @click="dlgAttendance.show()">New
                        Event</v-btn>
                </v-card-text>
            </v-card>
            <data-table :tableData="tableData" @pageChanged="pageChanged">
                <template v-slot:[`item.dutyDate`]="{ item }">
                    <span>{{ moment(item.dutyDate).format("D-MMM-yyyy") }} </span>
                </template>
                <template v-slot:[`item.reportingTime`]="{ item }">
                    <span>{{ moment(item.reportingTime).format("hh:mm A") }}</span>
                </template>
                <template v-slot:[`item.Actions`]="{ item }">
                    <v-menu>
                        <template v-slot:activator="{ props }">
                            <v-btn icon="mdi-dots-vertical" v-bind="props" size="small" variant="icon" />
                        </template>
                        <v-list density="compact">
                            <v-list-item title="QR Code" prepend-icon="mdi-qrcode" @click="viewQr(item)" />
                            <v-list-item title="View" prepend-icon="mdi-eye-circle-outline" @click="viewAttendance(item.attendanceId)" />
                            <v-list-item
                                v-if="item.createdBy === authStore.user?.itsId"
                                title="Admins"
                                prepend-icon="mdi-account-cog"
                                @click="openAdminsDialog(item.attendanceId)"
                            />
                        </v-list>
                    </v-menu>
                </template>
            </data-table>
        </v-col>
    </v-row>

    <simple-dialog ref="dlgAttendance" width="500" title="New Attendance" cancelButtonText="Close" @ok="submitForm"
        hide-confirm-button hide-cancel-button>
        <template v-slot:content>
            <AddAttendanceView @onClose="dlgAttendance.hide()" @onSave="onAttendanceSaved(false)" />
        </template>
    </simple-dialog>

    <simple-dialog ref="dlgEditAttendance" width="500" title="Edit Attendance" cancelButtonText="Close" @ok="submitForm"
        hide-confirm-button hide-cancel-button>
        <template v-slot:content>
            <EditAttendanceView :attendanceId="attendanceId" @onClose="dlgEditAttendance.hide()"
                @onSave="onAttendanceSaved(true)" />
        </template>
    </simple-dialog>

    <simple-dialog ref="dlgAttendanceQr" cancelButtonText="Close" :hideConfirmButton="true">
        <template v-slot:content>
            <QrCodeView :attendance="selectedAttendance" />
        </template>
    </simple-dialog>

    <simple-dialog ref="dlgEventAdmins" width="700" title="Event Admins" cancelButtonText="Close"
        hide-confirm-button>
        <template v-slot:content>
            <EventAdminsView v-if="selectedAttendanceId" :attendanceId="selectedAttendanceId" />
        </template>
    </simple-dialog>
</template>

<script setup>
import { ref, reactive, onMounted, inject } from 'vue';
import * as atService from '@/services/attendanceService';
import { useRouter } from "vue-router";
import { useAuthStore } from "@/setup/stores/authStore";
import moment from 'moment';
import QrCodeView from './QrCodeView.vue';
import AddAttendanceView from './AddAttendanceView.vue';
import EditAttendanceView from './EditAttendanceView.vue';
import EventAdminsView from './EventAdminsView.vue';

const loader = inject("loader");
const snackbar = inject("snackBar");
// const confirmDialog = inject("confirmDialog");
const router = useRouter();
const authStore = useAuthStore();

var dlgAttendance = ref(null);
var dlgEditAttendance = ref(null);
var dlgAttendanceQr = ref(null);
var dlgEventAdmins = ref(null);

const attendanceId = ref(0);
const selectedAttendanceId = ref(0);
const selectedAttendance = reactive({});

const pageContext = reactive({
    search: "",
    pageNumber: 1,
    pageSize: 20,
    organizationId: 0,
    AttendanceTypeId: 0,
    ShowDivisionEvents: false
});

const tableData = reactive({
    headers: [
        { title: "S. No", key: "SNo" },
        { title: "Team", key: "organization.name" },
        { title: "Duty Date", key: "dutyDate" },
        { title: "Details", key: "description" },
        { title: "Reporting Time", key: "reportingTime" },
        { title: "Actions", key: "Actions" }
    ],
    data: [],
    itemsPerPage: 15,
    totalItems: 0,
    paginationContext: {},
});

async function getData() {
    loader.show();

    let result = await atService.master_getAll(pageContext)
        .catch(error => console.log(error))
        .finally(() => {
            loader.hide();
        });

    if (result) {
        tableData.data = result.items;
        tableData.paginationContext = {
            pageSize: pageContext.pageSize,
            currentPage: result.currentPage,
            totalCount: result.totalCount,
            totalPages: result.totalPages,
            hasNext: result.hasNext,
            hasPrevious: result.hasPrevious,
        };
    }
}

async function onAttendanceSaved(isEdit) {
    snackbar.success(isEdit);

    if (isEdit)
        dlgEditAttendance.value.hide();
    else
        dlgAttendance.value.hide();

    await getData();
}

function viewQr(att) {
    selectedAttendance.value = att;
    dlgAttendanceQr.value.show();
}

function viewAttendance(attendanceId) {
    router.push(`/attendance/${attendanceId}`);
}

function openAdminsDialog(id) {
    selectedAttendanceId.value = id;
    dlgEventAdmins.value.show();
}

// function editAttendance(att) {
//     attendanceId.value = att.attendanceId;
//     dlgEditAttendance.value.show();
// }

// async function deleteAttendance(att) {
//     const isDelete = await confirmDialog.confirm("Delete Attendance", `Are you sure you want to delete this event: ${att.description}? Please confirm.`, 'Yes', 'No', true);
//     if (!isDelete)
//         return;

//     await atService.master_delete(att.attendanceId)
//         .then(() => snackbar.success("Attendance has been deleted successfully"))
//         .catch(error => {
//             snackbar.error(error);
//             console.log(error);
//         })

//     await getData();
//     loader.hide();
// }

async function pageChanged(pageNo) {
    pageContext.pageNumber = pageNo;
    await getData();
}

onMounted(async () => {
    await getData();
});
</script>

<style>
.button-spacing {
    margin: 10px;
}

.v-card {
    overflow: unset !important;
}

.custom-margin-top {
    margin-top: 10px;
}

.custom-margin-bottom {
    margin-bottom: 10px;
}
</style>